import tools from './tools.js';
import store from '@/store';

//暂停所有媒体
const pauseMedia = function() {
    let videos = document.getElementsByTagName('video');
    if (videos && videos.length > 0) {
        Array.from(videos).forEach(element => {
            element.pause();
        });
    }
    let audios = document.getElementsByTagName('audio');
    if (audios && audios.length > 0) {
        Array.from(audios).forEach(element => {
            element.pause();
        });
    }
}
/**
 * app交互
 */
/**
 * app版本记录
 * 22080100
 * * 选择图片成功的回调方法由updateSuccess修改为uploadSuccess
 * 22093000
 * * 添加分享和拨打电话功能
 * 23042600
 * * 点击返回顶部
 * 23060800
 * * 打开微信小程序
 * 23061600
 * * 支付功能
 * 24061300 
 * * 打开小程序添加参数 AppId
 * 
 */
const handlerName = ['loginSuccess', 'uploadSuccess', 'updateSuccess', 'paymentResult', 'backPage', 'backTop', 'refreshPageData'];

export default {
    bridge: null,
    handlerFn: {},
    //app准备
    ready: function(callback){
        if(!tools.isYdApp()){
            callback();
            return;
        }
        if (tools.isIos()) {
            tools.setupWKWebViewJavascriptBridge((bridge)=>{
                if(bridge){
                    this.bridge = bridge;
                    handlerName.forEach(name => {
                        bridge.registerHandler(name, (...arg)=>{
                            let fn = this.handlerFn[name];
                            if(fn) fn(...arg);
                        });
                    });
                }
                callback();
            })
        }else{
            callback();
        }
    },
    /**调用原生 原生方法*/

    //获取app原生信息和加密的key
    getAppInfo: function(){
        return new Promise(resolve=>{
            if(!tools.isYdApp()){
                store.commit('setAppInfo', {
                    ClientId: "",
                    RequestNowVersion: "WEB_12_OQPDA",
                    RequestDigestKey: "PiArSjfSHt2hbvjDN4682bd3CMbTd6fn", 
                    RequestEncryptKey: "gziuEeiEzU9pWPBBHNTmgR8Q", 
                    ResponseDigestKey: "e3VG8L8RXLPj7NWqn49UkQEjXxbePmvp",
                    ResponseEncryptKey: "4u3a9ocrrRBDpEZfVHq4QAvB"
                });
                resolve();
                return;
            }
            if (tools.isIos()) {
                if(this.bridge){
                    this.bridge.callHandler('getAppInfo', {}, function (responseData) { 
                        var data = responseData || {};
                        store.commit('setAppInfo', data);
                        resolve();
                    })
                }else{
                    resolve();
                }
            } else {
                var data = JSON.parse(window?.cesyd?.getAppInfo() || '{}');
                store.commit('setAppInfo', data);
                resolve();
            }
        })
    },
    //获取请求需要的原生数据
    getAppData: function(){
        return new Promise(resolve=>{
            if(process.env.NODE_ENV == "production" && tools.isYdApp()){
                if (tools.isIos()) {
                    if(this.bridge){
                        this.bridge.callHandler('getAppData', {}, function (responseData) { 
                            var data = responseData || {};
                            store.commit('setToken', data.Token);
                            resolve(data);
                        })
                    }else{
                        resolve({});
                    }
                } else {
                    var data = JSON.parse(window?.cesyd?.getAppData() || '{}');
                    store.commit('setToken', data.Token);
                    resolve(data);
                }
            }else{
                var data = {Timestamp: tools.secondTimestamp()};
                resolve(data);
            }
        })
    },

    //请求错误调用原生
    requestError: function(Code){
        if (tools.isIos()) {
            if(this.bridge){
                this.bridge.callHandler('requestError', {Code}, function () { })
            }
        } else {
            window?.cesyd?.requestError(JSON.stringify({Code}))
        }
    },

    //关闭WebView
    closeWebView: function(Type = 0){
        pauseMedia();
        if (tools.isIos()) {
            if(this.bridge){
                this.bridge.callHandler('closeWebView', {Type}, function () { })
            }
        } else {
            window?.cesyd?.closeWebView(JSON.stringify({Type}));
        }
    },

    //原生登陆
    go2Login: function(Type){
        return new Promise(resolve=>{
            if (tools.isIos()) {
                if(this.bridge){
                    this.handlerFn.loginSuccess = function (data = {}) {
                        resolve(data);
                    }
                    this.bridge.callHandler('toLogin', {Type}, function () { })
                }
            } else {
                window?.cesyd?.toLogin(JSON.stringify({Type}));
                window.loginSuccess = function(data = "{}"){
                    resolve(JSON.parse(data));
                }
            }
        })
    },
    //重置Token
    resetToken: function(SessionToken){
        if (tools.isIos()) {
            if(this.bridge){
                this.bridge.callHandler('resetToken', SessionToken, function () { })
            }
        } else {
            window?.cesyd?.resetToken(JSON.stringify(SessionToken));
        }
    },

    //获取当前用户是否登录，登录类型是什么
    getUserState: function(){
        return new Promise(resolve=>{
            if(process.env.NODE_ENV == "production"){
                if (tools.isIos()) {
                    if(this.bridge){
                        this.bridge.callHandler('getUserState', {}, function (responseData) { 
                            var data = responseData || {};
                            store.commit('setUserType', data.Type);
                            resolve(data.Type);
                        })
                    }else{
                        store.commit('setUserType', 0);
                        resolve(0);
                    }
                } else {
                    var data = JSON.parse(window?.cesyd?.getUserState() || '{}');
                    store.commit('setUserType', data.Type);
                    resolve(data.Type);
                }
            }else{
                let type = localStorage.getItem('UserType');
                store.commit('setUserType', type);
                resolve(type);
            }
        })
    },

    //设置导航栏样式
    setTabStyle: function(obj={}){
        if(!tools.isYdApp())return;
        if (tools.isIos()) {
            if(this.bridge){
                this.bridge.callHandler('setTabStyle', obj, function () {})
            }
        } else {
            window?.cesyd?.setTabStyle(JSON.stringify(obj));
        }
    },

    //保存图片到本地
    saveImage: function(ImgUrl){
        if (tools.isIos()) {
            if(this.bridge){
                this.bridge.callHandler('saveImage', {ImgUrl}, function () {})
            }
        } else {
            window?.cesyd?.saveImage(JSON.stringify({ImgUrl}));
        }
    },

    //保存文件到本地
    saveFile: function(FileUrl,FileName){
        if (tools.isIos()) {
            if(this.bridge){
                this.bridge.callHandler('saveFile', {FileUrl,FileName}, function () {})
            }
        } else {
            window?.cesyd?.saveFile(JSON.stringify({FileUrl,FileName}));
        }
    },

    //选择图片
    updatePortrait: function(obj){
        return new Promise(resolve=>{
            if (tools.isIos()) {
                if(this.bridge){
                    this.bridge.callHandler('updatePortrait', obj, function () {})

                    if(tools.isVersion('22080100')){
                        this.handlerFn.uploadSuccess = function (data = {}) {
                            resolve(data);
                        }
                    }else{
                        this.handlerFn.updateSuccess = function (data = {}) {
                            data.Url = data.PortraitUrl;
                            resolve(data);
                        }
                    }
                }
            } else {
                window?.cesyd?.updatePortrait(JSON.stringify(obj));

                if(tools.isVersion('22080100')){
                    window.uploadSuccess = function(data = "{}"){
                        resolve(JSON.parse(data));
                    }
                }else{
                    window.updateSuccess = function(data = "{}"){
                        data = JSON.parse(data);
                        data.Url = data.PortraitUrl;
                        resolve(data);
                    }
                }
            }
        })
    },

    //使用新的webview打开地址
    webviewOpenUrl: function(Url){
        if(process.env.NODE_ENV == "production"){
            if (tools.isIos()) {
                if(this.bridge){
                    this.bridge.callHandler('webviewOpenUrl', {Url}, function () {})
                }
            } else {
                window?.cesyd?.webviewOpenUrl(JSON.stringify({Url}));
            }
        }else{
            window.open(Url);
        }
    },

    //分享
    share: function(params = {}){
        if (tools.isIos()) {
            if(this.bridge){
                this.bridge.callHandler('share', params, function () {})
            }
        } else {
            window?.cesyd?.share(JSON.stringify(params));
        }
    },

    //拨打电话
    makingCalls: function(TelNo){
        if (tools.isIos()) {
            if(this.bridge){
                this.bridge.callHandler('makingCalls', {TelNo}, function () {})
            }
        } else {
            window?.cesyd?.makingCalls(JSON.stringify({TelNo}));
        }
    },
    //打开微信小程序
    /**
     * 
     * {wxPageUrl, AppId}
     */
    jumpWxMiniApp: function(wxPageUrl, AppId = 'gh_accf53497871'){
        if(tools.isIos()){
            if(this.bridge){
                this.bridge.callHandler('jumpWxMiniApp', {
                    wxPageUrl,
                    AppId
                });
            }
        }else{
            window?.cesyd?.jumpWxMiniApp(JSON.stringify({
                wxPageUrl,
                AppId
            }));
        }
    },

    //支付
    /**
     * @param {*} params 
     * { Provider, PayParams }
     * @returns 
     * { Status }
     */
    requestPayment: function (params){
        return new Promise(resolve=>{
            if (tools.isIos()) {
                if(this.bridge){
                    this.handlerFn.paymentResult = function (data = {}) {
                        resolve(data);
                    }

                    this.bridge.callHandler('requestPayment', params);
                }
            } else {
                //调用
                window?.cesyd?.requestPayment(JSON.stringify(params));
                //结果
                window.paymentResult = function(data = "{}"){
                    resolve(JSON.parse(data));
                }
            }
        })
    },

    /**原生调用 web方法 */

    //原生点击后退
    backPage: function(callback){
        if(!tools.isYdApp())return;
        if (tools.isIos()) {
            if(this.bridge){
                this.handlerFn.backPage = function (data, responseCallback) {
                    callback();
                    responseCallback(1);
                }
            }
        } else {
            window.backPage = function(){
                callback();
                return '1';
            }
        }
    },

    //tabbar点击 返回顶部
    backTop: function(callback){
        if (tools.isIos()) {
            if(this.bridge){
                this.handlerFn.backTop = function (data, responseCallback) {
                    callback();
                }
            }
        } else {
            window.backTop = function(){
                callback();
            }
        }
    },
    //刷新页面数据
    refreshPageData: function(callback){
        if (tools.isIos()) {
            if(this.bridge){
                this.handlerFn.refreshPageData = function (data = {}) {
                    callback(data);
                }
            }
        } else {
            window.refreshPageData = function(data = "{}"){
                callback(JSON.parse(data));
            }
        }
    }
}